import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormArray, FormControl } from '@angular/forms';
import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { FlashMessagesService } from 'angular2-flash-messages';
import { CreateSizeComponent } from '../create-size/create-size.component';
import { MatDialog } from "@angular/material";
import { ConfirmationDialogComponent } from "../../shared/confirmation-dialog/confirmation-dialog.component";
import { CommonService } from "../../_services/common.service";

@Component({
  selector: 'app-add-size',
  templateUrl: './add-size.component.html',
  styleUrls: ['./add-size.component.css']
})
export class AddSizeComponent implements OnInit {
  public showLoader: boolean = false;
  public sizeList:Array<any>=[];
  constructor(private router: Router,
    private formBuilder: FormBuilder,
    private _flashMessagesService: FlashMessagesService,
    private dialog: MatDialog,
    private CommonService: CommonService) { }

  ngOnInit() {
    this.getSizeList();
  }

  getSizeList=function(){
    this.showLoader=true;
    this.CommonService.apiService(
      "GET",
      "sizes/" + localStorage.getItem("userID")     
    ).subscribe(
      (response: any) => {
        if (response.status === true) {
          this.showLoader=false;
          if (response.data) {
            this.sizeList = response.data;
          }
        }
      },
      err => {
        this.showLoader=false;
        console.log(err);
      }
    );
  }

  openSizeDialog(): void {
    const dialogRef = this.dialog.open(CreateSizeComponent, {
      width: "250px",
      data: {
        //name:'test'

      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.sizeList = [];
        this.getSizeList();
      }
    });
  }

  openUpdateSizeDialog(sizeId, name) {
    const dialogRef = this.dialog.open(CreateSizeComponent, {
      width: "250px",
      data: {
        size_id: sizeId,
        name: name
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.sizeList = [];
        this.getSizeList();
      }
    });
  }


  openDialog(id: number): void {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      width: "250px",
      data: {
        name: "Admin",
        message: "Are you sure you want to delete this size",
        manageData: { id: id }
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result && result.id) {
        this.deleteSize(result.id);
      }
    });
  }

  deleteSize = function (id) {
    let attributeOptions = {    
    };
    this.CommonService.apiService(
      "DELETE",
      "size/delete/"+id+"/"+localStorage.getItem("userID"),
      attributeOptions
    ).subscribe(
      (response: any) => {
        if (response.status === true) {
          this.sizelist = [];
          this.getSizeList();
          this._flashMessagesService.show("Size deleted successfully!", {
            cssClass: "alert-success",
            timeout: 5000
          });

        }
      },
      err => {
        this._flashMessagesService.show(err.error.message, {
          cssClass: "alert-danger",
          timeout: 5000
        });
      }
    );
  }
  trackByFn(index: any, item: any) {
    return index;
  }

}



// WEBPACK FOOTER //
// /var/www/login.theprintlife.com/src/app/mnt-products/add-size/add-size.component.ts